module.exports = __webpack_public_path__ + "img/eff01Big1.f6f205ca.png";